import { render, staticRenderFns } from "./SmilePhotoAligner.vue?vue&type=template&id=50ea4b80&"
import script from "./SmilePhotoAligner.vue?vue&type=script&lang=js&"
export * from "./SmilePhotoAligner.vue?vue&type=script&lang=js&"
import style0 from "./SmilePhotoAligner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports